import { widgetsConfigurations } from 'config/widgetConfigurations/widgetsConfigurations';

import { IComponentKey, IHashmap } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

/**
 * 🎯 Purpose:
 * Defines the list of widget component keys that are part of Portfolio Dashboard,
 * and do not have project and contract context
 */

export const PORTFOLIO_COMPONENT_KEYS: IComponentKey[] = [
    widgetsConfigurations.projectScorecards.componentKey as keyof IHashmap,
    widgetsConfigurations.timelineAndDensity.componentKey as keyof IHashmap,
];
